import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, List, ListItemButton, ListItemText, MenuItem, OutlinedInput, Select, Stack, Typography, } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { TransportGroupRoundedIcon } from 'app/icons';
import { autocolonNotSelectedItemsTransportSelector, divisionItemsTransportSelector } from 'app/selectors/transport';
import { useAsyncAction } from 'app/services';
import { createDivisionAutocolon } from 'app/store/transport';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
const AutocolonDialog = ({ open, onClose }) => {
    const [type, setType] = useState();
    const [selectedDivision, setSelectedDivision] = useState(null);
    const [selectedAutocolons, setSelectedAutocolons] = useState([]);
    const [unselectedAutocolons, setUnselectedAutocolons] = useState([]);
    const [name, setName] = useState(null);
    const { asyncAction: create, isLoading: isCreateLoading, isSuccessful: isCreateSuccessful, isError: isCreateError, } = useAsyncAction(createDivisionAutocolon, [open]);
    const handleFormSubmit = () => {
        if (!type || !name)
            return;
        create({
            type,
            name,
            selectedAutocolons,
            id_division: selectedDivision,
        });
        handleClose();
    };
    const handleChangeType = (e) => {
        setName('');
        setSelectedDivision(null);
        setSelectedAutocolons([]);
        setType(e.target.value);
    };
    const handleChangeName = (e) => {
        setName(e.target.value);
    };
    const handleChangeDivision = (e) => {
        setSelectedDivision(e.target.value);
    };
    const handleClose = () => {
        onClose();
        setSelectedDivision(null);
        setType(undefined);
        setSelectedAutocolons([]);
        setName(null);
    };
    useEffect(() => {
        if (isCreateSuccessful) {
            handleClose();
        }
    }, [isCreateSuccessful]);
    const autocolons = useSelector(autocolonNotSelectedItemsTransportSelector);
    const divisions = useSelector(divisionItemsTransportSelector);
    const newAutocolons = () => {
        const selectedAutocolonsIds = selectedAutocolons.map((item) => item.id);
        return autocolons.filter((autocolon) => !selectedAutocolonsIds.includes(autocolon.id));
    };
    const handleToggleAutocolon = ({ id, name: autocolonName }) => {
        if (selectedAutocolons.find((item) => item.id === id)) {
            setSelectedAutocolons(selectedAutocolons.filter((item) => item.id !== id));
            if (!autocolons.find((autocolon) => autocolon.id === id)) {
                setUnselectedAutocolons([...unselectedAutocolons, { id, name: autocolonName }]);
            }
            return;
        }
        setSelectedAutocolons([...selectedAutocolons, { id, name: autocolonName }]);
        if (unselectedAutocolons.find((autocolon) => autocolon.id === id)) {
            setUnselectedAutocolons(unselectedAutocolons.filter((item) => item.id !== id));
        }
    };
    return (React.createElement(Dialog, { maxWidth: 'md', fullWidth: true, open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialog-paper': {
                minWidth: '460px',
                minHeight: '460px',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(1.5),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '18px',
                    height: '18px',
                },
                'path, circle': {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
            '.MuiInputLabel-root': {
                position: 'relative',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                legend: {
                    overflow: 'visible',
                    span: {
                        opacity: 1,
                        bgcolor: '#fff',
                    },
                },
            },
            '& .MuiTypography-root': {
                fontSize: '0.8em',
            },
            '& .MuiListItemText-root': {
                padding: 0,
                margin: 0,
            },
            '& .MuiListItemButton-root': {
                padding: '4px 0',
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(TransportGroupRoundedIcon, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'p' }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D \u0438\u043B\u0438 \u0430\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u0443"),
            React.createElement(IconButton, { color: 'default', onClick: onClose },
                React.createElement(Close, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true, onSubmit: handleFormSubmit },
                    React.createElement(Select, { value: type, label: '\u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D \u0438\u043B\u0438 \u0430\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u0430?', onChange: handleChangeType },
                        React.createElement(MenuItem, { value: 'division' }, "\u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D"),
                        React.createElement(MenuItem, { value: 'autocolon' }, "\u0410\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u0430")),
                    type === 'autocolon' && (React.createElement(React.Fragment, null,
                        React.createElement(Stack, { sx: { paddingTop: '10px' } },
                            React.createElement(OutlinedInput, { label: '\u0410\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u0430', notched: true, fullWidth: true, value: name, onChange: handleChangeName, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0410\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B' }),
                            React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")),
                        React.createElement(Stack, { sx: { paddingTop: '10px' } },
                            React.createElement(Select, { value: selectedDivision, label: '\u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D', variant: 'outlined', onChange: handleChangeDivision },
                                React.createElement(MenuItem, { value: 0, key: 0 }, "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u043E\u0442\u043E\u0432\u0441\u0435\u0445"),
                                divisions.map((division) => (React.createElement(MenuItem, { value: division.id, key: division.id }, division.name))))))),
                    type === 'division' && (React.createElement(React.Fragment, null,
                        React.createElement(Stack, { sx: { paddingTop: '10px' } },
                            React.createElement(OutlinedInput, { label: '\u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D', notched: true, fullWidth: true, value: name, onChange: handleChangeName, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0430' }),
                            React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")),
                        React.createElement(Stack, { direction: 'row', sx: { width: '100%', paddingTop: '10px' } },
                            React.createElement(Stack, { sx: { width: '50%' } },
                                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B"),
                                React.createElement(List, null, selectedAutocolons.map(({ id, name: autocolonName }) => {
                                    return (React.createElement(ListItemButton, { key: id, onClick: () => handleToggleAutocolon({ id, name: autocolonName }) },
                                        React.createElement(ListItemText, { primary: autocolonName })));
                                }))),
                            React.createElement(Stack, { sx: {
                                    paddingTop: '10px',
                                    width: '50%',
                                } },
                                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u041D\u0435\u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B"),
                                React.createElement(List, null,
                                    unselectedAutocolons.map(({ id, name: autocolonName }) => {
                                        return (React.createElement(ListItemButton, { key: id, onClick: () => handleToggleAutocolon({ id, name: autocolonName }) },
                                            React.createElement(ListItemText, { primary: autocolonName })));
                                    }),
                                    newAutocolons().map(({ id, name: autocolonName }) => {
                                        return (React.createElement(ListItemButton, { key: id, onClick: () => handleToggleAutocolon({
                                                id,
                                                name: autocolonName,
                                            }) },
                                            React.createElement(ListItemText, { primary: autocolonName })));
                                    }))))))),
                !isCreateLoading && isCreateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")))),
        React.createElement(Stack, { direction: 'row', sx: { justifyContent: 'space-between' } },
            React.createElement(DialogActions, null,
                React.createElement(LoadingButton, { variant: 'contained', loading: isCreateLoading, onClick: onClose, disableElevation: true }, "\u041E\u0442\u043C\u0435\u043D\u0430")),
            React.createElement(DialogActions, null,
                React.createElement(LoadingButton, { variant: 'contained', loading: isCreateLoading, disableElevation: true, onClick: handleFormSubmit }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")))));
};
export default AutocolonDialog;
